import React, { FC } from 'react';
import { withTheme } from 'styled-components';

import { StyledLoader, StyledLeg, StyledHead, StyledBody } from './FadingLoader.styles';

export interface FadingLoaderProps {}

const FadingLoader: FC<FadingLoaderProps> = (props) => (
  <StyledLoader data-testid="FadingLoader" {...props}>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 73 55"
      xmlSpace="preserve"
    >
      <g>
        <StyledHead
          d="M72.4,12c0.1-0.6,0.2-1.2,0.2-1.9C72.6,4.5,68,0,62.5,0H43.3l-2.1,14.5c-0.2,1-0.2,2-0.1,3.2c0.6,4.7,4.3,8.4,9,8.9 c0.4,0.1,0.7,0.1,1.1,0.1h8.6v17.8c0,3.7,3,6.7,6.7,6.7h4.7v-6.7h-1.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.1,0-0.2,0-0.3L72.4,12z"
        />
        <StyledBody
          d="M49.7,30c-6.2-0.7-11.2-5.6-12-11.8c-0.2-1.3-0.1-2.5,0.1-3.8l1.6-11H25.1C15,3.4,6.7,11.2,5.5,21.2l-5,33.4h8.6L12.9,41 h27.9v13.5h8.3L52.8,30h-1.6C50.8,30,50.3,30,49.7,30z"
        />
        <StyledLeg points="12.5,54.5 21.2,54.5 25.4,44.4 15.4,44.4" />
      </g>
    </svg>
  </StyledLoader>
);

export default withTheme(FadingLoader);
